import './StallProfilePage.css';
import StallsByUser from '../../components/Stalls/stallsByUser/StallsByUser';



const StallProfilePage = () => {

  return (
    <div>
      <StallsByUser />
    </div>
  )
}

export default StallProfilePage
